import { useRef } from 'react';
import classes from './search.module.css';

interface SearchWidgetProps {
  searchText: string;
  setSearchText: (newText: string) => void;
  showFilterDialog: boolean;
  toggleFilterDialog: () => void;
}

export const SearchWidget = (props: SearchWidgetProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleSubmit = (event: React.FormEvent) => {
    const searchText = inputRef.current?.value || '';
    console.log('submitted', searchText);
    props.setSearchText(searchText);
    event.preventDefault();
  };
  return (
    <div className={classes.SearchWidget}>
      <div className="magnifying-glass">
        <img src="/magnifying-glass.svg" />
      </div>
      <div className="search-text">
        <form onSubmit={handleSubmit}>
          <input
            id="saerch-text"
            ref={inputRef}
            type="text"
            defaultValue={props.searchText}
            placeholder="Enter search text..."
            onBlur={handleSubmit}
          />
        </form>
      </div>
      <div className="funnel">
        <button type="button" onClick={props.toggleFilterDialog}>
          {!props.showFilterDialog && <img src="/funnel.svg" />}
          {!!props.showFilterDialog && <img src="/x-mark.svg" />}
        </button>
      </div>
    </div>
  );
};
